import { render, staticRenderFns } from "./TetrisGame1.vue?vue&type=template&id=69328a04&scoped=true&"
import script from "./TetrisGame1.vue?vue&type=script&lang=js&"
export * from "./TetrisGame1.vue?vue&type=script&lang=js&"
import style0 from "./TetrisGame1.vue?vue&type=style&index=0&id=69328a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69328a04",
  null
  
)

export default component.exports